import { render } from "./ShoppingInline.vue?vue&type=template&id=1b62303b"
import script from "./ShoppingInline.vue?vue&type=script&lang=js"
export * from "./ShoppingInline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__